<template>
    <b-container class="p-0">
        <div class="rw-choose-correct-answer">
            <text-input class="h5" v-if="value.label1" :value="value.label1.data"/>
        </div>
    </b-container>
</template>

<script>

import TextInput from './components/TextInput.vue'
import {
    // BRow,
    // BCol,
    // BCard,
    // BModal,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'rw_complete_story',
    components: {
        TextInput,
        // BRow,
        // BCol,
        // BCard,
        // BModal,
        BContainer,
    },
    props: {
        value: Object
    },

}
</script>